import { ApiError } from "@/lib/types";
import { QueryClient } from "@tanstack/react-query";

export const newQC = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const customError = error as unknown as ApiError;
        if (customError?.code === 404) {
          return failureCount < 0;
        }
        try {
          return failureCount < 2;
        } catch (e: unknown) {
          console.log(e);
          return failureCount < 2;
        }
      },
      retryDelay: 1000,
    },
  },
});
